import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';
import { GroupDto, GroupDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { ManageGroupType } from './managegrouptype';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { ManageGroupView } from './managegroupview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ManageGroupCSSStyleImpl } from './managegroupcss';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { ManageGroupAPIModelImpl, ManageGroupAPIModel } from './managegroupapimodel';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';


export interface ManageGroupProps extends UIComponentProps
{
    groupDto: GroupDto;
    manageGroupType: ManageGroupType;
    
    onCancelClicked(): void;
    onBackClicked(): void;
}

export interface ManageGroupState extends UIComponentState
{
    manageGroupType: ManageGroupType;
    groupName: string;
    listOfGroupMembers: MemberDetailsDto[];
}

export interface ManageGroupHandler extends UIComponentHandler
{
    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto, groupName: string): void;
    onAddMemberClicked(memberDetailsDto: MemberDetailsDto, groupName: string): void;

    showEditMode(): void;
    onEditGroupClicked(groupName: string): void;
    onCreateGroupClicked(groupName: string): void;
}

export class ManageGroupComponent extends UIComponentImpl<ManageGroupProps, ManageGroupState, UIDataModel> implements ManageGroupHandler
{
    private deletedList: string[] = [];
    private existingMembersList: string[];

    constructor(props: ManageGroupProps)
    {
        super(props);

        this.existingMembersList = [];
        this.existingMembersList = props.groupDto.getMembersList().map((t: MemberDetailsDto) =>
        {
           return t.getMsisdn();
        }); 
        console.log("existingMembersList: " + JSON.stringify(this.existingMembersList));
        this.state = {groupName: props.groupDto.getGroupName(), listOfGroupMembers: props.groupDto.getMembersList(), manageGroupType: props.manageGroupType};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ManageGroupView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ManageGroupCSSStyleImpl(applicationContext);
    }

    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ManageGroupAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: ManageGroupProps)
    {
        this.setState({groupName: nextProps.groupDto.getGroupName(),
            listOfGroupMembers: nextProps.groupDto.getMembersList(), manageGroupType: nextProps.manageGroupType});
    }
    

    validate(): boolean
    {
       return (this.getView() as ManageGroupView).validate();
    }

    showEditMode(): void {
      this.setState({manageGroupType: ManageGroupType.EDIT});
    }

    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto, groupName: string): void 
    {
       let isExists = this.existingMembersList.findIndex(((t: string, index: number)=>
        {
            return  t === memberDetailsDto.getMsisdn();
        }));

        isExists !== -1 && this.deletedList.push(memberDetailsDto.getMsisdn());

        this.setState({groupName: groupName, listOfGroupMembers: this.state.listOfGroupMembers.filter((t: MemberDetailsDto)=>
            {
                return t.getMsisdn() !== memberDetailsDto.getMsisdn();
            })});
    }

    onAddMemberClicked(memberDetailsDto: MemberDetailsDto, groupName: string): void 
    {
        this.deletedList = this.deletedList.filter(((t: string)=>
        {
            return t !== memberDetailsDto.getMsisdn();
        }));

        this.state.listOfGroupMembers.push(memberDetailsDto);
       
        this.setState({groupName: groupName, listOfGroupMembers: this.state.listOfGroupMembers});
    }

    onCreateGroupClicked(groupName: string)
    {
        let groupDto = this.props.groupDto as GroupDtoImpl;

        groupDto.setGroupName(groupName);
        let listofmembers =  this.state.listOfGroupMembers.filter((memberDetailsDto: MemberDetailsDto, index: number) =>
        {
            return index !== 0 && memberDetailsDto;
        });
        // groupDto.setMembersList(this.state.listOfGroupMembers);
        groupDto.setMembersList(listofmembers);
        groupDto.setDeletedMembersList(this.deletedList);

        console.log("onCreate: " + JSON.stringify(groupDto));

       (this.getAPIModel() as ManageGroupAPIModel).onCreateGroup(groupDto);
    }
     
    onEditGroupClicked(groupName: string)
    {
        let groupDto = this.props.groupDto as GroupDtoImpl;

        groupDto.setGroupName(groupName);
       let listofmembers =  this.state.listOfGroupMembers.filter((memberDetailsDto: MemberDetailsDto, index: number) =>
        {
            return index !== 0 && memberDetailsDto;
        });
        // groupDto.setMembersList(this.state.listOfGroupMembers);
        groupDto.setMembersList(listofmembers);
        groupDto.setDeletedMembersList(this.deletedList);
        console.log("onEdit: " + JSON.stringify(groupDto));

        (this.getAPIModel() as ManageGroupAPIModel).onEditGroup(groupDto);
    }
    
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        this.deletedList.length = 0;

       if(feature === APIFeatures.CREATE_GROUP)
       {
          this.props.onCancelClicked();
       }
       else if(feature === APIFeatures.EDIT_GROUP)
       {
         this.props.onCancelClicked();
       }
    }

    onFaliure(feature: APIFeatures, description: string, data: any): void 
    {
      console.log("-----deascription: " + description);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/managegroupcomponent.tsx